/**
 * Keep in sync with tenant pack jobs/src/components/marketing/marketing-guest-header-bar.tsx
 */
import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

/** Shared guest marketing nav row — landing, public share, jobs board. */
export const MARKETING_GUEST_HEADER_ROW_CLASS =
  'flex w-full items-center justify-between gap-3 py-4 sm:gap-4'

export const MARKETING_GUEST_HEADER_ACTIONS_CLASS =
  'flex shrink-0 flex-nowrap items-center justify-end gap-3 sm:gap-4'

type MarketingGuestHeaderBarProps = {
  brand: ReactNode
  actions: ReactNode
  className?: string
  actionsClassName?: string
}

export function MarketingGuestHeaderBar({
  brand,
  actions,
  className,
  actionsClassName,
}: MarketingGuestHeaderBarProps) {
  return (
    <div className={cn(MARKETING_GUEST_HEADER_ROW_CLASS, className)}>
      <div className="min-w-0 shrink-0">{brand}</div>
      <div className={cn(MARKETING_GUEST_HEADER_ACTIONS_CLASS, actionsClassName)}>{actions}</div>
    </div>
  )
}
